import { PAYMENT_STATUS_CHIP } from '../format';
import type { PaymentStatus } from '../types';

import styles from './payment-status-chip.module.scss';

/** Payment status pill with its Figma-exact colorway (per-status class in the module). */
export function PaymentStatusChip({ status }: { status: PaymentStatus }) {
  return (
    <span className={[styles.chip, styles[status]].filter(Boolean).join(' ')}>
      {PAYMENT_STATUS_CHIP[status].label}
    </span>
  );
}
